import React, { useEffect, useState } from 'react'
import BtnSpinner from '../../components/BtnSpinner';
import { Save, X } from 'lucide-react';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import { useParams } from 'react-router-dom';

function AddOrEditChapter({ close, setRefresh, chapter }) {

    // console.log(chapter,'chapter')

    const {course_id} = useParams();

    const [data, setData] = useState({
        chapterId: "",
        title: "",
        chapterImage: "",
        description: "",
        status:""
    });
    const [isEdit, setIsEdit] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [loading, setLoading] = useState({ state: false, name: "" });
    const token = localStorage.getItem("token");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update preview image when image URL changes
        if (name === 'chapterImage') {
            setPreviewImage(value);
        }
    };

    const handleReset = () => {
        setData({
            chapterId: "",
            title: "",
            chapterImage: "",
            description: "",
        });
        setPreviewImage("");
        setIsEdit(false);
    };

    useEffect(() => {

        if (chapter) {
            setData({
                chapterId: chapter?.chapterId,
                title:chapter?.title,
                chapterImage: chapter?.chapterImage,
                description: chapter?.description,
                status:chapter?.status
            });
            setPreviewImage(chapter?.chapterImage)
            setIsEdit(true)
        }

        return () => {
            setData({
                chapterId: "",
                title: "",
                chapterImage: "",
                description: "",
            })
            setIsEdit(false);
            setPreviewImage(null)
        }
    }, [chapter]);

    const handleAddChapter= async()=>{
        setLoading({state:true,name:"addchapter"})
        try {
            const addRes= await Apirequests(`chapter/create-chapter`,'POST',data,{
                Authorization: `Bearer ${token}`,
                course_id: course_id
            });

            if(addRes?.success){
                SuccessTost(addRes?.message);
                close();
                setRefresh((prev)=>!prev)
            }else{
                ErrorTost(addRes?.message)
            }
        } catch (error) {
            console.log(error,'add chapter error')
            ErrorTost("Something went wrong, please try again later")
        }
        setLoading({state:false,name:""})
    };

    const handleEditChapter= async(id)=>{
        setLoading({state:true,name:"editchapter"})
        try {
            const addRes= await Apirequests(`chapter/edit-chapter/${id}`,'PUT',data,{
                Authorization: `Bearer ${token}`,
                course_id: course_id
            });

            if(addRes?.success){
                SuccessTost(addRes?.message);
                close();
                setRefresh((prev)=>!prev)
            }else{
                ErrorTost(addRes?.message)
            }
        } catch (error) {
            console.log(error,'add chapter error')
            ErrorTost("Something went wrong, please try again later")
        }
        setLoading({state:false,name:""})
    }

    const handleSubmit= async(e)=>{
        e.preventDefault();
        console.log(chapter,'chapter',data);
        if(chapter){
            await handleEditChapter(chapter?.chapterId)
        }else{
            await handleAddChapter();
        }
    };








    return (
        <div className="py-2 px-2 sm:px-2 lg:px-2">
            <div>
                {/* Header */}
                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {isEdit ? 'Edit Chapter' : 'Add New Chapter'}
                    </h1>
                    <div className="flex gap-4">
                        {!isEdit && <button
                            onClick={handleReset}
                            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700"
                        >
                            Reset Form
                        </button>}
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="bg-white rounded-2xl">
                    {/* Image Preview */}
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Chapter Image Preview
                        </label>
                        <div className="relative h-72 w-full bg-gray-100 rounded-lg overflow-hidden">
                            {previewImage ? (
                                <img
                                    src={previewImage}
                                    alt="Course preview"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="flex items-center justify-center h-full text-gray-400">
                                    No image preview available
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Basic Information */}
                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Chapter Title *
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={data.title}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter chapter title"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Image URL *
                            </label>
                            <input
                                type="url"
                                name="chapterImage"
                                value={data.chapterImage}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter image URL"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Chapter Id
                            </label>
                            <input
                                type="text"
                                name="chapterId"
                                value={data.chapterId}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter chapter ID"
                            />
                        </div>

                       
                    </div>

                    {/* Course Details */}
                    <div>
                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Price *
                            </label>
                            <input
                                type="tel"
                                name="course_price"
                                value={data.course_price}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter price"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Discount Percentage
                            </label>
                            <input
                                type="number"
                                name="course_discount_percentage"
                                value={data?.course_discount_percentage}
                                onChange={handleInputChange}
                                min="0"
                                max="100"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter discount"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Rating
                            </label>
                            <input
                                type="tel"
                                name="course_rating"
                                value={data.course_rating}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter rating"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Total Lessons *
                            </label>
                            <input
                                type="tel"
                                name="total_lesson"
                                value={data.total_lesson}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total lessons"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Total Chapters *
                            </label>
                            <input
                                type="tel"
                                name="total_chapters"
                                value={data.total_chapters}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total chapters"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Precedence Level *
                            </label>
                            <input
                                type="tel"
                                name="course_precedance"
                                value={data.course_precedance}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total chapters"
                            />
                        </div> */}

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status *
                            </label>
                            <select
                                name="status"
                                value={data.status}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="Active">Active</option>
                                <option value="Disabled">Disabled</option>
                            </select>
                        </div>
                    </div>

                    {/* Description */}
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Chapter Description *
                        </label>
                        <textarea
                            name="description"
                            value={data.description}
                            onChange={handleInputChange}
                            rows="4"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter chapter description"
                        />
                    </div>

                    {/* Form Actions */}
                    <div className="flex gap-4">
                        {isEdit ? <button
                            type="submit"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                        >
                            {
                                loading.state && loading.name === "editchapter" ?
                                    <BtnSpinner /> :
                                    <>
                                        <Save className="w-5 h-5" />
                                        <span className='text-white'>Update Chapter</span>
                                    </>
                            }

                        </button>
                            :
                            <button
                                type="submit"
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                            >
                                {
                                    loading.state && loading.name === "addchapter" ?
                                        <BtnSpinner /> :
                                        <>
                                            <Save className="w-5 h-5" />
                                            <span className='text-white'>Create Chapter</span>
                                        </>
                                }

                            </button>}
                        <button
                            type="button"
                            onClick={()=>close()}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                        >
                            <X className="w-5 h-5" />
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddOrEditChapter